/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */
export function warn (msg) {
  console.error(`[Glide warn]: ${msg}`)
}
